import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="w-full max-w-2xl text-center">

        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100">
          <CheckCircle2
            size={48}
            className="text-emerald-600"
          />
        </div>

        <div className="mb-4 text-sm font-bold uppercase tracking-[0.18em] text-emerald-600">
          FounderScaleCapital
        </div>

        <h1 className="mb-5 text-4xl font-bold text-slate-900 sm:text-5xl">
          Thank You!
        </h1>

        <p className="mx-auto mb-3 max-w-xl text-lg leading-relaxed text-slate-600">
          We've received your fundraising enquiry.
        </p>

        <p className="mx-auto mb-8 max-w-xl text-base leading-relaxed text-slate-500">
          Our team will review your requirements and get in touch with
          you shortly.
        </p>

        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-lg bg-emerald-600 px-7 py-3.5 text-sm font-bold text-white shadow-lg shadow-emerald-600/20 transition hover:bg-emerald-700"
        >
          Back to FounderScaleCapital
        </Link>

      </div>
    </div>
  );
};

export default ThankYou;
